import _ from 'lodash';

import * as api from '../../../api';

import { useTranslation } from 'react-i18next';
import { Box, Card, HStack, Typography } from '@vivaahealth/design-system';
import { useState } from 'react';

import TextData from '../../TextData';
import Row from '../../Row';
import EditEmergencyContactModal from './EmergencyContactsModal/EditEmergencyContactModal';
import EmergencyContactButton from './EmergencyContactButton';

import { maybeFormatNumberToNational } from '../../../utils/phoneNumber';

interface EmergencyContactProps {
  rank: number;
  emergencyContacts: api.Previsit.PatientEmergencyContact[];
  emergencyContactRelationships: api.Patient.EmergencyContactRelationship[];
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  startsAtOne: boolean;
}

const EmergencyContactCard = (props: EmergencyContactProps) => {
  const { t } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);
  const {
    rank,
    emergencyContacts,
    saveFieldValue,
    updateFieldValue,
    emergencyContactRelationships,
    startsAtOne,
  } = props;
  const {
    firstName,
    lastName,
    cellPhoneNumber,
    homePhoneNumber,
    emergencyContactRelationshipToPatient,
  } = emergencyContacts[startsAtOne ? rank - 1 : rank];
  let phoneDetails: { type: string; number: string };
  const fullName = `${_.capitalize(firstName)} ${_.capitalize(lastName)}`;

  if (cellPhoneNumber) {
    phoneDetails = {
      type: t('mobilePhone'),
      number: maybeFormatNumberToNational(cellPhoneNumber) || '–',
    };
  } else if (homePhoneNumber) {
    phoneDetails = {
      type: t('homePhone'),
      number: maybeFormatNumberToNational(homePhoneNumber) || '–',
    };
  } else {
    phoneDetails = {
      type: 'Phone',
      number: '–',
    };
  }

  const relationshipValue =
    api.Previsit.relationshipMap[emergencyContactRelationshipToPatient];

  return (
    <>
      <Card.Header background="gray">
        <HStack justifyContent="space-between" alignItems="center" width="100%">
          <Typography variant="title-large" bold>
            {fullName}
          </Typography>
          <EmergencyContactButton
            variant="text"
            onClickHandler={() => setIsOpen(true)}
            message={t('edit')}
            size="small"
          />
        </HStack>
      </Card.Header>
      <Box paddingY={12}>
        <Row>
          <TextData
            label={`${phoneDetails.type}`}
            value={phoneDetails.number}
          ></TextData>
          <TextData
            label={t('relationship')}
            value={t(relationshipValue)}
          ></TextData>
        </Row>
      </Box>
      {isOpen ? (
        <EditEmergencyContactModal
          topLabel={t('editEmergencyContact', { ns: 'emergencyContacts' })}
          rank={rank}
          emergencyContacts={emergencyContacts}
          onModalClose={() => setIsOpen(false)}
          isOpen={isOpen}
          saveFieldValue={saveFieldValue}
          updateFieldValue={updateFieldValue}
          isEditExperience
          emergencyContactRelationships={emergencyContactRelationships}
          startsAtOne={startsAtOne}
        />
      ) : null}
    </>
  );
};

export default EmergencyContactCard;
